module.exports = __webpack_public_path__ + "img/icon-dapp-rns.440a791f.svg";